export default class Form {

  constructor () {
    this.$scroller = null
  }

  setScroller ($scroller) {
    this.$scroller = $scroller
  }

  validator (request) {
    let flag = []
    const regex = /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
  
    Object.keys(request).map(field => {
      
      if(!request[field].value && !request[field].hasOwnProperty('optional')) {
  
        flag.push({
          'type': 'error',
          'text': 'Le champ ' + request[field].title + ' doit être renseigné'
        })
  
      }
      
      if(field == 'email') {
        if(!regex.test(request[field].value)) {
          flag.push({
            'type': 'error',
            'text': 'Veuillez renseigner une adresse mail valide'
          })
        }
      }
  
    })
  
    return flag
  }

  view ({ form, messages }) {

    const feedbacks = form.querySelector('.-js-feedbacks')
    const btn = form.querySelector('button[type="submit"]')
  
    if (feedbacks) {
      feedbacks.innerHTML = ''
  
      if (messages) {
        messages.map(message => {
          feedbacks.innerHTML += '<span class="'+ message.type +'">' + (message.type == 'debug' ? JSON.stringify(message.text) : message.text) + '</span>'
        })
      }
    }
  
    btn.disabled = false
    btn.style.cursor = 'pointer'
    form.style.opacity = 1
    
    if (this.$scroller) this.$scroller.update()
  
  }
}